import React, { useRef, useCallback, useState, useEffect } from 'react'
import dayjs from 'dayjs'
import useUpload from '../../hooks/useUpload'
import Quill from 'quill'
import qs from 'qs'
import 'quill/dist/quill.snow.css'
import './index.scss'
import { uploadFile, getDraft, getDiary, getDiaryAbstract } from '../../api'
import actionDict from '../../util/getActionDict'
import { clearUselessInfo, getImgDict } from './tools'
import { getParams, getSize, getType, getEntry } from '../../util/tools'
import { getBlotNode, getLoadingDom, isMatterLink } from '../../util/dom'
import '../../util/createBlot'
import MenuBox from './components/MenuBox/index'
import isLeave from '../../util/leavingTip'
import { Toast, Modal } from 'antd-mobile'
import {
  autoSave,
  getPublishParams,
  goPublish,
  insertBlot,
} from './tools/index'
import DetailBar from './components/DetailBar'
import { placeholderDict, editorTypeDict } from '../../util/dict'
import deleteImg from './tools/deleteImg'
const classNames = require('classnames')
const { toolbarCallback, toolbarAction } = actionDict
const alert = Modal.alert

const Delta = require('quill-delta')

const savingFlag = { flag: false }

const { flutter ,token } = qs.parse(window.location.search.substr(1)) as {
  flutter: string | undefined
  token: string | undefined
}

const Editor: React.FC = () => {
  const editorRef = useRef<null | Quill>(null),
    fileDict = useRef<FileDict>({}),
    tempId = useRef(0),
    [showMenuBox, _setShowMenuBox] = useState<MenuType>(false),
    showMenuBoxRef = useRef<MenuType>(false),
    editorIdx = useRef(0),
    uploadType = useRef<InsertType>('file'),
    taskId = useRef<string>(''),
    draftId = useRef<string>(''),
    editorType = useRef<EditorType>('matter'),
    imgDict = useRef<{ [k: string]: string }>({}),
    scrollTopRef = useRef(0),
    [toolbarTop, setToolbarTop] = useState(0),
    [isNull, setIsNull] = useState(true),
    isNullRef = useRef(true),
    getParamsRef = useRef<GetPublishParamsFn>(),
    [confirmTxt, setConfirmTxt] = useState<'保存' | '发送'>('保存'),
    firstEnter = useRef(false),
    menuBoxRef = useRef<{ setFormat: () => void; editorFormat: object }>(),
    initContent = useRef(''),
    [showTool, setShowTool] = useState(true),
    [titleInput, setTitleInput] = useState(''),
    [titleDisable, setTitleDisable] = useState(false),
    [detailDisplay, setDetailDisplay] = useState(false),
    [refTasksCount, setRefTasksCount] = useState(0),
    [isNote, setIsNote] = useState(false),
    [needTitle, setNeedTitle] = useState(false),
    beforeLeave = useRef(() => {}),
    displayRef = useRef(false),
    displayImgs = useRef<{ uniId: string; id: string }[]>([]),
    [loading, setLoading] = useState(false),
    [loadingWrapper, setLoadingWrapper] = useState(false),
    [updateTip, setUpdateTip] = useState(''),
    [hasContent, setHasContent] = useState(false),
    [insertIcons, setInsertIcons] = useState<InsertType[]>([]),
    [edType, setEdType] = useState<EditorType>('matter')

  function setShowMenuBox(b: MenuType) {
    showMenuBoxRef.current = b
    _setShowMenuBox(b)
  }

  useEffect(() => {
    console.log('checkcheck!fix idx idx!!')
    window.addEventListener('scroll', function () {
      const scrollTop = window.pageYOffset
      setToolbarTop(scrollTop >= 0 ? scrollTop : 0)
      scrollTopRef.current = this.screenTop
    })
  }, [])

  const checkFiles: CheckFilesFn = async ({
    checkOnly,
    type,
    clearUnuploadedFiles,
  }) => {
    const editor = editorRef.current
    if (!editor) return false

    const delta = editor.getContents(),
      { ops } = delta,
      file_id: string[] = [],
      image_id: string[] = [],
      affected_uid: string[] = [],
      removedFileIds: string[] = [],
      checkFlag = { isChecked: false },
      files: ParamsFiles = []

    for (let op of ops) {
      const insert = op.insert
      if (insert && typeof insert === 'object' && 'INSERT_FILE' in insert) {
        const info = insert as {
          INSERT_FILE: {
            tempId: string
            fileId: string | null
            type: InsertType
            id: string
            userId: string
            origin: string
          }
        }

        const { type: insertType, tempId, fileId, origin } = info.INSERT_FILE

        // @
        if (insertType === 'people') {
          affected_uid.push(info.INSERT_FILE.userId)
        }

        // file/img
        if (insertType === 'file' || insertType === 'img') {
          const id = fileId || fileDict.current[tempId].id
          if (id) {
            file_id.push(id)
            files.push({
              id,
              file_id: id,
              origin,
              entry: getEntry(),
            })
            // img
            if (insertType === 'img') {
              image_id.push(id)
            }
          } else {
            removedFileIds.push(tempId)
            if (!checkFlag.isChecked && !clearUnuploadedFiles) {
              checkFlag.isChecked = true
              if (!(await isLeave(type))) {
                editor.focus()
                return false
              }
            }
          }
        }
      }
    }

    !clearUnuploadedFiles &&
      removedFileIds.forEach((id) => {
        const delDom = document.querySelector(`#blot_${id}`)
        delDom?.parentNode?.removeChild(delDom)
      })

    if (checkOnly) return true

    return {
      file_id,
      image_id,
      affected_uid,
      editor,
      files,
    }
  }

  getParamsRef.current = getPublishParams({
    checkFiles,
    fileDict,
    imgDict,
    tempId,
    taskId,
    isNullRef,
    editorRef,
  })

  beforeLeave.current = () => {
    window.localStorage.setItem('doNotFly', '1')
    const editor = editorRef.current
    if (!editor) return
    window.localStorage.setItem('content', editor.root.innerHTML)
    window.localStorage.setItem(
      'fileInfo',
      JSON.stringify({
        fileDict: fileDict.current,
        tempId: tempId.current,
      })
    )

    if (editorType.current === editorTypeDict.DIARY) {
      window.localStorage.setItem(
        'diaryLocalInfo',
        JSON.stringify({
          _title: titleInput,
          _refTasks: refTasksCount,
          _isNote: isNote,
        })
      )
    }
  }

  const getDiaryLocalInfo = useCallback(() => {
    const info = window.localStorage.getItem('diaryLocalInfo')

    if (info) {
      const { _title, _refTasks, _isNote } = JSON.parse(info)
      setTitle(_title)
      setIsNote(_isNote)
      setRefTasksCount(_refTasks)
      setNeedTitle(true)
    }
  }, [])

  function setTitle(v: string) {
    v = v || ''
    setTitleInput(v)
    window.localStorage.setItem('inputTitle', v)
  }

  const initHtml = useCallback(async (html: string, getFileIds: boolean) => {
    const editor = editorRef.current
    if (!editor) return

    console.log('init html', html)

    editor.root.innerHTML = html
      .replace(/&amp;/g, '&')
      .replace(/url\('\//g, "url('./")
      .replace(/&quot;/g, "'")

    displayImgs.current = await getImgDict({ imgDict })

    // const imgDoms = document.querySelectorAll('.blot-common_img[data-file]'),
    //   imgUrls = [...imgDoms].map(
    //     (node) => node.getAttribute('data-file') as string
    //   )

    // if (imgUrls.length) {
    //   let urlDict = (await getOnlineImgs(imgUrls)).data.data
    //   imgDoms.forEach((node) => {
    //     const dom = node as HTMLLinkElement
    //     const fileId = dom.getAttribute('data-file') as string
    //     imgDict.current[fileId] = urlDict[fileId]
    //     dom.style.backgroundImage = `url('${urlDict[fileId]}')`
    //     const { uniId, id } = qs.parse(node.getAttribute('href') as string) as {
    //       uniId: string
    //       id: string
    //     }
    //     displayImgs.current.push({
    //       uniId,
    //       id,
    //       // url: dom.style.backgroundImage.replace('url("', '').replace('")', ''),
    //     })
    //   })
    // }

    if (getFileIds) {
      const ogFileIds = [
        ...document.querySelectorAll('.blot-common'),
      ].map((node) => node.getAttribute('data-file'))

      window.localStorage.setItem('ogFileIds', JSON.stringify(ogFileIds))
    }
  }, [])

  const getFileInfo = () => {
    let fileInfo = window.localStorage.getItem('fileInfo')
    if (fileInfo) {
      const obj = JSON.parse(fileInfo) as { tempId: number; fileDict: FileDict }
      tempId.current = obj.tempId
      fileDict.current = obj.fileDict
    }
  }

  const inputCallback = useCallback((files: FileList | File[]) => {
    const editor = editorRef.current,
      curFileDict: FileDict = {}

    if (files && files.length && editor) {
      let insertIdx =
        editorRef.current?.getSelection()?.index ||
        parseInt(window.localStorage.getItem('focusIdx') || '0')

      if (isNaN(insertIdx)) {
        insertIdx = 0
      }

      const handler = (file: File, insertIdx: number) => {
        const id = tempId.current
        tempId.current = id + 1

        const isImg = file.type.startsWith('image'),
          url = isImg ? URL.createObjectURL(file) : ''

        curFileDict[id] = {
          file,
          state: 'pending',
          tempId: id,
          url,
          type: isImg ? 'image' : 'file',
        }

        const { name, size } = file

        editor.insertEmbed(
          insertIdx,
          'INSERT_FILE',
          {
            tempId: id,
            title: name,
            size,
            type: isImg ? 'img' : 'file',
            file,
            url,
            origin: '本地文件',
          },
          'user'
        )
      }

      insertBlot({
        insertIdx,
        files: [...files],
        editor,
        handler,
      }).then(() => {
        fileDict.current = {
          ...fileDict.current,
          ...curFileDict,
        }
      })
    }

    return { curFileDict, fileDict }
  }, [])

  const uploader = useUpload(inputCallback)

  const insertPeople = useCallback(async () => {
    if (!(await checkFiles({ checkOnly: true, type: 'tempLeave' }))) return
    beforeLeave.current()
    const taskId = window.localStorage.getItem('taskId')

    if (flutter) {
      window.location = (`js://webview?trigger=people${
        taskId ? `&H5TaskId=${taskId}` : ''
      }` as unknown) as Location
      return
    }

    wx.miniProgram.redirectTo({
      url: `/pages/contacts-selector/index?isEditor=true&isH5=1${
        taskId ? `&H5TaskId=${taskId}` : ''
      }`,
    })
  }, [])

  const insertMatter = useCallback(async () => {
    if (!(await checkFiles({ checkOnly: true, type: 'tempLeave' }))) return
    beforeLeave.current()

    if (flutter) {
      window.location = ('js://webview?trigger=matter' as unknown) as Location
      return
    }

    wx.miniProgram.redirectTo({
      url: '/pages/record/pages/relation-task/index?mode=edit&isH5=1',
    })
  }, [])

  const initFromDraft = useCallback(
    (recordId: string, localInfo: string) => {
      alert('', '是否加载上次未同步的内容？', [
        {
          text: '取消',
          onPress: () => {
            window.localStorage.removeItem(`draft-diary-${recordId}`)
          },
        },
        {
          text: '确定',
          onPress: () => {
            const { content, title } = JSON.parse(localInfo)
            setTitle(title)
            const { html, tempId: temp } = JSON.parse(content)
            tempId.current = temp
            initHtml(html, recordId !== 'new')
            // window.localStorage.setItem('compareParams', localInfo)
            window.localStorage.removeItem(`draft-diary-${recordId}`)
          },
        },
      ])
    },
    [initHtml]
  )

  function setTimeTip(createTime: number, updateTime: number) {
    const timeTip = dayjs((updateTime || createTime) * 1000).format(
      'YYYY年MM月DD日 H:mm'
    )

    const prefix = updateTime === createTime ? '保存于' : '更新于'

    setUpdateTip(prefix + timeTip)
  }

  const setDisplay = useCallback(
    async (display: boolean) => {
      if (display) {
        editorRef.current?.disable()
        // update time tip
        const recordId = window.localStorage.getItem('recordId') as string
        const { create_at, update_at } = await getDiaryAbstract(recordId)
        setTimeTip(create_at, update_at)
      } else {
        editorRef.current?.enable()
        // 读取本地缓存 编辑记录/笔记
        const recordId = window.localStorage.getItem('recordId')
        const localInfo = window.localStorage.getItem(`draft-diary-${recordId}`)
        if (localInfo && recordId) {
          initFromDraft(recordId, localInfo)
        }
      }
      displayRef.current = display
      setTitleDisable(display)
      setDetailDisplay(display)
    },
    [initFromDraft]
  )

  // 首次进入执行
  const getInitInfo = useCallback(async () => {
    clearUselessInfo()
    window.localStorage.setItem('focusIdx', '0')

    console.log('首次进入')

    const { taskId, dispatchId, detailTaskId, sharedDiary } = qs.parse(
      window.location.search.substr(1)
    ) as {
      taskId: string
      dispatchId: string
      detailTaskId: string
      sharedDiary: string
    }

    sharedDiary && window.localStorage.setItem('sharedDiary', '1')
    taskId && window.localStorage.setItem('taskId', taskId)
    dispatchId && window.localStorage.setItem('dispatchId', dispatchId)
    if (taskId && dispatchId) {
      window.localStorage.setItem('isNote', '1')
      setIsNote(true)
    }

    let _content = ''

    switch (editorType.current) {
      // 事项/会议详情
      case editorTypeDict.DETAIL: {
        _content = initContent.current
        detailTaskId &&
          window.localStorage.setItem('detailTaskId', detailTaskId)
        break
      }
      // 会议纪要需先查看服务器是否有草稿
      case editorTypeDict.MEETING: {
        try {
          const res = await getDraft(taskId)
          let {
            data: { content, draft_id },
          } = res.data

          _content = content
          draftId.current = draft_id
          window.localStorage.setItem('draftId', draft_id)
        } catch (e) {
          console.log('无此会议纪要')
        }
        break
      }
      // 事项结论需先查看本地是否有草稿
      case editorTypeDict.MATTER: {
        _content =
          window.localStorage.getItem(`draft-conclusion-${taskId}`) || ''
        break
      }
      // 个人笔记
      case editorTypeDict.DIARY: {
        setNeedTitle(true)
        const { recordId } = qs.parse(window.location.search.substr(1)) as {
          recordId: string
        }

        if (recordId) {
          setLoadingWrapper(true)
          window.localStorage.setItem('recordId', recordId)
          const {
            title,
            content,
            ref_tasks,
            isNote,
            createTime,
            updateTime,
          } = await getDiary(recordId)

          setTimeTip(createTime, updateTime)

          window.localStorage.setItem(
            'compareParams',
            JSON.stringify({
              title: title || '',
              content: content || '',
            })
          )
          _content = content

          setTitle(title)
          ref_tasks && setRefTasksCount(ref_tasks.length)
          setIsNote(isNote)
          setTimeout(() => {
            // 设置为展示状态
            setDisplay(true)
            setLoadingWrapper(false)
          }, 100)
        } else {
          const localInfo = window.localStorage.getItem('draft-diary-new')
          if (localInfo) {
            initFromDraft('new', localInfo)
          }
        }
        break
      }
      default: {
        console.error('initHTML未命中编辑器类型')
        break
      }
    }

    if (!_content) return

    let html, _tempId

    try {
      const { html: _html, tempId: _temp } = JSON.parse(_content)
      html = _html
      _tempId = _temp
    } catch (e) {
      html = _content
      _tempId = 100
    }

    tempId.current = _tempId
    initHtml(html, true)
  }, [initHtml, initFromDraft, setDisplay])

  function setNull() {
    const editor = editorRef.current
    if (!editor) return
    const isContentNull =
      editor.getContents().ops.length <= 1 &&
      !editor.root.innerText.trim() &&
      !draftId.current

    const isDiary =
      window.localStorage.getItem('editorType') === editorTypeDict.DIARY

    isNullRef.current = isDiary
      ? isContentNull && !window.localStorage.getItem('inputTitle')
      : isContentNull

    setHasContent(!isContentNull)
    setIsNull(isNullRef.current)
  }

  // callback for toolbar action
  const handleInsert = useCallback(
    async (editor: Quill) => {
      const params = qs.parse(window.location.search.substr(1)) as UrlParams,
        paramsArr = getParams(params)

      if (!paramsArr) {
        // 首次进入
        console.log('first enter')
        firstEnter.current = true
        try {
          getInitInfo()
        } catch (e) {
          console.log('get inif info fail', e)
        }
        return
      }

      // 暂时离开后的回来
      const content = window.localStorage.getItem('content') as string,
        needClearTxt = window.localStorage.getItem('needClearTxt'),
        isNote = window.localStorage.getItem('isNote')

      let idx = parseInt(window.localStorage.getItem('focusIdx') as string)

      window.localStorage.removeItem('needClearTxt')

      if (isNote) setIsNote(true)

      console.log('temp back', content)

      getDiaryLocalInfo()
      getFileInfo()

      await initHtml(content, false)

      setNull()

      const paramsKey = paramsArr[0] as InsertType,
        paramsValue = paramsArr[1]

      if (paramsValue === 'cancel') return

      if (needClearTxt) editor.deleteText(--idx, 1)

      toolbarCallback({ editor, idx, paramsValue })[paramsKey]()
    },
    [initHtml, getInitInfo, getDiaryLocalInfo]
  )

  const initEditor = useCallback(async () => {
    console.log('ready fileInfo')

    const { id, type, initContent: _content } = qs.parse(
      window.location.search.substr(1)
    ) as {
      id: string
      type: EditorType
      initContent: string
    }

    if (type) {
      window.localStorage.setItem('editorType', type)
      window.localStorage.setItem('taskId', id)
    }

    initContent.current = _content || ''

    editorType.current =
      type || (window.localStorage.getItem('editorType') as EditorType)

    const insertIcons: InsertType[] = ['people', 'matter', 'img', 'file']

    setEdType(editorType.current)

    if (editorType.current === 'diary') {
      insertIcons.push('font')
    }
    setInsertIcons([...insertIcons])

    setConfirmTxt(
      editorType.current === editorTypeDict.MATTER ? '发送' : '保存'
    )

    taskId.current = id || (window.localStorage.getItem('taskId') as string)

    const editor = (editorRef.current = new Quill('#editor', {
      theme: 'snow',
      modules: {
        toolbar: {
          container: '#toolbar',
        },
      },
      placeholder: placeholderDict[editorType.current],
    }))

    let blurToSave: Function | undefined

    // 自动保存
    if (getParamsRef.current) {
      blurToSave = await autoSave(
        getParamsRef.current,
        editorType.current,
        displayRef,
        setLoading
      )
    }

    handleInsert(editor)

    document.querySelector('.ql-editor')?.addEventListener('click', (e) => {
      if (menuBoxRef.current) {
        setShowMenuBox(false)
      }

      const linkInfo = isMatterLink(e.target as HTMLElement)

      if (linkInfo && displayRef.current) {
        e.stopPropagation()
        e.preventDefault()
        const { type, id, href } = linkInfo
        if (type === 'matter') {
          if (flutter) {
            window.location = (`js://webview?trigger=share_detail&id=${id}` as unknown) as Location
            return
          }
          wx.miniProgram.navigateTo({
            url: '/pages/task/pages/share-detail/index?t=' + id,
          })
        }
        if (type === 'file') {
          let { id, title, size } = qs.parse(href) as {
            id: string
            title: string
            size: string
          }

          const prefix = 'hrefId-'
          if (id.startsWith(prefix)) {
            const k = id.replace(prefix, '')
            id = fileDict.current[k].id as string
          }

          if (flutter) {
            window.location = (`js://webview?trigger=file&?id=${id}&title=${title}&size=${getSize(
              parseInt(size)
            )}` as unknown) as Location
            return
          }

          wx.miniProgram.navigateTo({
            url: `/pages/file-download/index?id=${id}&title=${title}&size=${getSize(
              parseInt(size)
            )}&type=doc`,
          })
        }
        if (type === 'img') {
          let { uniId, id } = qs.parse(linkInfo.href) as {
            uniId: string
            id: string
          }

          const prefix = 'hrefId-'
          if (id.startsWith(prefix)) {
            const k = id.replace(prefix, '')
            id = fileDict.current[k].id as string
          }

          const idx = displayImgs.current.findIndex(
            (item) => item.uniId === uniId
          )

          if (flutter) {
            window.location = (`js://webview?trigger=img&?info=${JSON.stringify(
              {
                id,
                imgs: displayImgs.current,
                index: idx,
              }
            )}` as unknown) as Location
            return
          }

          wx.miniProgram.navigateTo({
            url: `/pages/viewGallery/index?info=${JSON.stringify({
              id,
              imgs: displayImgs.current,
              index: idx,
            })}&flyele_type=${window.localStorage.getItem('editorType')}`,
          })
        }
        return
      }

      editor.enable()

      displayRef.current && setDisplay(false)

      const blotNode = getBlotNode(e.target as HTMLElement)
      if (blotNode) {
        const id = blotNode.id,
          fileData = fileDict.current[id]

        if (fileData && fileData.state === 'fail') {
          // reset loading status
          fileData.state = 'pending'
          getLoadingDom(blotNode.node)
          // retry upload
          uploadFile({
            fileDict,
            curFileDict: {
              [id]: fileData,
            },
          })
        }
      }
    })

    document.querySelector('.ql-editor')?.addEventListener('focus', () => {
      console.log('focus', editor.getSelection()?.index)
    })

    function handleBlur() {
      setTimeout(() => {
        if (savingFlag.flag) {
          savingFlag.flag = false
          return
        }
        console.log('blur save')
        blurToSave && blurToSave()
      }, 500)
    }

    setTimeout(() => {
      document
        .querySelector('.title-input')
        ?.addEventListener('blur', handleBlur)

      document.querySelector('.ql-editor')?.addEventListener('blur', () => {
        const focusIdx = editorRef.current?.getSelection()?.index
        focusIdx && window.localStorage.setItem('focusIdx', focusIdx + '')
        handleBlur()
      })
    }, 500)

    editor.on('text-change', async (delta) => {
      if (firstEnter.current) {
        firstEnter.current = false
        return
      }

      const { ops } = delta,
        doNotFly = window.localStorage.getItem('doNotFly'),
        trigger =
          (!doNotFly && ops[0] && ops[0].insert) || (ops[1] && ops[1].insert)

      window.localStorage.removeItem('doNotFly')

      if (trigger === '@' || trigger === '#') {
        window.localStorage.setItem('needClearTxt', '1')
        if (trigger === '@') {
          insertPeople()
        }
        if (trigger === '#') {
          insertMatter()
        }
      }
    })

    // 复制黏贴
    editor.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
      // console.log('check -->', delta, node.innerText)

      if (!node.innerText) {
        return new Delta()
      }

      return new Delta()
        .insert(node.innerText, menuBoxRef?.current?.editorFormat)
        .insert('\n')
    })

    // editor.clipboard.addMatcher(Node.TEXT_NODE, (node, delta) => {
    //   console.log('paste text', node, delta)
    //   isPasted = true
    //   // 复制黏贴为纯文本
    //   let ops: any[] = []
    //   delta.ops.forEach((op) => {
    //     ops.push({
    //       insert: node.nodeValue,
    //       attributes: menuBoxRef?.current?.editorFormat,
    //     })
    //   })

    //   delta.ops = ops

    //   return delta
    // })

    editor.on('editor-change', (...res: any) => {
      deleteImg(editor, res)

      // 失焦
      if (res[0] === 'selection-change' && !res[1]) return
      if (editor) {
        menuBoxRef.current?.setFormat()

        const idxGetter = editor.getSelection()

        setNull()

        const [type, , , trigger] = res
        // 焦点复位
        if (
          ['selection-change', 'text-change'].includes(type) &&
          trigger === 'api'
        ) {
          setTimeout(() => {
            const idx = window.localStorage.getItem('focusIdx') || '0'
            editor.setSelection(parseInt(idx), 0)
          })
          return
        }

        if (idxGetter) {
          editorIdx.current = idxGetter.index
          window.localStorage.setItem('focusIdx', idxGetter.index + '')
        }

        // window.localStorage.setItem('content', editor.root.innerHTML)
      }
    })
  }, [handleInsert, insertMatter, insertPeople, setDisplay])

  // toobar actions
  function insertStuff(type: InsertType): void {
    const editor = editorRef.current
    editor?.blur()

    if (!editor) return

    const curIdx = editor.getSelection()?.index

    if (!curIdx && curIdx !== 0) {
      editorIdx.current = 0
    }

    const uploaderDom = uploader.current
    if (!uploaderDom) return

    toolbarAction(uploaderDom, setShowMenuBox, insertPeople, insertMatter)[
      type
    ]()

    uploadType.current = type
  }

  function showKeyboard() {
    editorRef.current?.enable()
    setShowMenuBox(false)
    editorRef.current?.focus()
  }

  async function confirmInput(needTrigger?: boolean) {
    editorRef.current?.blur()
    setShowMenuBox(false)

    savingFlag.flag = true

    if (!getParamsRef.current) return

    try {
      const params = await getParamsRef.current(false)

      if (!params) return

      if (!editorType.current) {
        Toast.fail('编辑器类型未定义')
      }

      // 事项详情
      if (editorType.current === 'detail') {
        wx.miniProgram.postMessage({ data: params })
        wx.miniProgram.navigateBack()
        return
      }

      if (loading) return

      await goPublish({
        params,
        draftId: draftId.current,
        needRedirect: true,
        setDisplay,
        setLoading,
        confirmToSave: true,
        displayImgs,
      })

      if (flutter && needTrigger) {
        window.location = (`js://webview?trigger=confirm&id=${window.localStorage.getItem(
          'recordId'
        )}` as unknown) as Location
      }
    } catch (e) {
      const errObj = e?.response?.data
      if (errObj && errObj.code === 40025) {
        Toast.info(errObj.message)
      } else {
        Toast.info('保存失败')
      }
    } finally {
      console.log('end')
    }
  }

  function getMenuBox(ins: { setFormat: () => void; editorFormat: object }) {
    menuBoxRef.current = ins
  }

  function handleTitleInput(e: React.ChangeEvent<HTMLInputElement>) {
    e.persist()
    const title = e.target.value
    setTitle(title)
    setNull()
  }

  if(!token) return <h1>invalid</h1>

  return (
    <div className="wrapper">
      {loadingWrapper && (
        <div className="loading-box">
          <img src="./images/loading.gif" alt="" />
        </div>
      )}
      <div
        id="toolbar"
        style={{
          top: toolbarTop + 'px',
          display: detailDisplay ? 'none' : 'flex',
        }}
      >
        <div className="tool">
          {!showTool && <div className="mask"></div>}
          {insertIcons.map((i) => (
            <button
              className="ql-insert"
              onClick={insertStuff.bind(null, i)}
              key={i}
            >
              <div
                className="btn-wrapper"
                style={{
                  backgroundColor: showMenuBox === i ? '#E6ECEC' : '',
                }}
              >
                <img src={`./images/icons/${i}.png`} alt="" className="icon" />
              </div>
            </button>
          ))}
        </div>

        <button
          className="confirm"
          onClick={confirmInput.bind(null, true)}
          style={isNull || loading ? { color: 'rgba(29, 210, 193, .3)' } : {}}
        >
          {edType !== 'matter' ? (
            loading ? (
              <img src="./images/loading.gif" alt="" className="confirm-icon" />
            ) : (
              <img
                src="./images/icons/nike.png"
                alt=""
                className="confirm-icon"
              />
            )
          ) : (
            confirmTxt
          )}
        </button>
      </div>

      {detailDisplay && (
        <DetailBar
          confirmInput={confirmInput}
          refTasksCount={refTasksCount}
          isNote={isNote}
          setIsNote={setIsNote}
          title={titleInput}
          editorRef={editorRef}
        />
      )}

      {needTitle && (
        <>
          <input
            type="text"
            className={classNames('title-input', {
              'title-input_hide': titleDisable,
            })}
            placeholder="标题"
            onFocus={() => {
              setShowTool(false)
              setShowMenuBox(false)
            }}
            onBlur={() => setShowTool(true)}
            onChange={handleTitleInput}
            value={titleInput}
            maxLength={16}
          />
          {titleDisable && (
            <div
              className="title-input"
              onClick={() => {
                setDisplay(false)
              }}
            >
              {titleInput}
            </div>
          )}
        </>
      )}

      <div
        id="editor"
        ref={initEditor}
        className={classNames({ 'editor-title': needTitle })}
        style={
          detailDisplay
            ? { height: 'auto', opacity: hasContent ? 1 : 0, minHeight: 'auto' }
            : {}
        }
      ></div>

      {detailDisplay && <div className="update-tip">{updateTip}</div>}

      <MenuBox
        ref={getMenuBox}
        menuType={showMenuBox}
        showKeyboard={showKeyboard}
        uploader={uploader}
        checkFiles={checkFiles}
        beforeLeave={beforeLeave}
        editorRef={editorRef}
        setShowMenuBox={setShowMenuBox}
      />
    </div>
  )
}

export default Editor
